import { Spin } from 'antd'
import React from 'react'

const SuspenseFallback = () => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      minHeight: 200,
    }}
  >
    <Spin size="large" />
  </div>
)

export default SuspenseFallback
